import { ChangeDetectionStrategy, Component, Input, ViewChild, output } from '@angular/core';

import { FileHandlerDefaultValidatorDirective } from './file-handler-default-validator.directive';
import type { FileReadResult } from './file-handler.directive';
import { FileHandlerDirective } from './file-handler.directive';
import type { FileTypesCategory } from '../accepted-file-types/accepted-file-types.types';

@Component({
  selector: 'rt-file-handler',
  template: `<div
    rtFileHandler
    rtFileHandlerDefaultValidator
    [rtFileHandlerValidateMaxSize]="true"
    [rtFileHandlerMultiple]="multiple"
    [rtFileHandlerAccept]="accept"
    (rtFileHandlerNextFile)="nextFile.emit($any($event))"
    hidden
  ></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FileHandlerDirective, FileHandlerDefaultValidatorDirective],
})
export class FileHandlerComponent {
  @Input()
  public validateMaxSize = false;

  @Input()
  public multiple = false;

  @Input()
  public accept: FileTypesCategory;

  public nextFile = output<FileReadResult>();

  @ViewChild(FileHandlerDirective)
  public instance: FileHandlerDirective;
}
